import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';

import { SITE_REGION_CODES } from '~/utils/societePayloadBuilder/regions';

import { FieldLabel } from './FieldLabels';

interface PayloadBuilderRegionChipsFieldProps {
  label: string;
  regions: Array<string>;
  onChange: (regions: Array<string>) => void;
  helperText?: string;
  required?: boolean;
}

export default function PayloadBuilderRegionChipsField({
  label,
  regions,
  onChange,
  helperText,
  required = false,
}: PayloadBuilderRegionChipsFieldProps) {
  const toggleRegion = (region: string) => {
    const next = regions.includes(region) ? regions.filter((code) => code !== region) : [...regions, region];
    onChange(next);
  };

  return (
    <>
      <FieldLabel required={required}>{label}</FieldLabel>
      {helperText ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
          {helperText}
        </Typography>
      ) : null}
      <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mb: 1 }}>
        {regions.map((region) => (
          <Chip key={region} label={region} onDelete={() => toggleRegion(region)} size="small" />
        ))}
      </Stack>
      <Stack direction="row" flexWrap="wrap" gap={0.5}>
        {SITE_REGION_CODES.filter((region) => !regions.includes(region)).map((region) => (
          <Chip
            key={region}
            label={region}
            variant="outlined"
            size="small"
            onClick={() => toggleRegion(region)}
            sx={{ cursor: 'pointer' }}
          />
        ))}
      </Stack>
    </>
  );
}
